export default class Footer {
	constructor() {

		this.section = document.querySelector('footer')
        this.footerMenu = this.section.querySelectorAll('.footer-menu')
        this.h3ul = this.section.querySelectorAll('.footer-menu ul')
		
		this.ready()
	}
	ready() {

		if (window.innerWidth < 770) {

            this.footerMenu.forEach((menu) => {
                menu.addEventListener('click', () => {

                    if(menu.classList.contains('active')) {
                        menu.classList.remove('active')
                    } else {
                        this.footerMenu.forEach((menuUncheck) => {
                            if(menuUncheck.classList.contains('active')) {
                                menuUncheck.classList.remove('active');
                            }
                        })
    
                        menu.classList.toggle('active')
                    }

                })
            })

        }

	}
}